import { IAgentFlags } from "store/entities/agents";

export const hashes = {
  hasClosedForwardingAddressesTip: "7a668774c188052c8beae3954602e956",
  hasClosedReplyAddressesTip: "2fe39ae4e39be27cdc2e282c3d050056",
  hasClosedForwardingInstructionsTooltip: "0efb9c1e9c598234451185cb71c96d37",
  confirmContactFormChangesDisabled: "732c8922412d51525ea8284aeab468d1",
  // settings sections
  emailAddressesSectionVisitedDate: "f47cf0406a5c271601e9b4e4d7b2f3bb",
  cannedResponsesSectionVisitedDate: "30373f16b7c52a3f110ce808a43edd49",
  tagsSectionVisitedDate: "8c4031c349fb5239730e71525a6a68e4",
  customFieldsSectionVisitedDate: "1c1baf4312b84ee5890ea1933eaca784",
  notificationsSectionVisitedDate: "d9444c7e748967c1a8bc774acfb01541",
  emailTemplatesSectionVisitedDate: "01ab84159b96e48364a6bb4e68319b98",
  myViewsSectionVisitedDate: "ed8fe37c586b30b9bd4fa53a64b9f298",
  integrationsSectionVisitedDate: "c0f575c08a280b5357e7f78fa8412160",
  automatedWorkflowsSectionVisitedDate: "de5d765238d3071e9ed7e39e06c7bf9d",
  contactFormsSectionVisitedDate: "8faa1ac9967167205328478ca439fe4d",
  spamSectionVisitedDate: "7537a83f92a2eca102637ffb090e734a",
  apiSectionVisitedDate: "694055d19f20cc75f18f64b5c4de8ca7",
  openWidgetSectionVisitedDate: "46cf18123eff5dfd32d6cfca0c8699c9",
  liveChatSectionVisitedDate: "45b18599dade7c7b8b7debd84881dc23",

  developerConsoleVisitedDate: "216ead2179779973a3dfd2cb1e4475ca",
  archiveVisitedDate: "44518562f2ff48a7f8d0de206c436996",
  contactFormsPromoClosed: "859a4f2fd9eaffb6e4bff485f67c068a",
  openWidgetSnippetCollapsed: "bfbf617971ef0c4b9b1057fb4b9b4954",
  closedMergingModalBanner: "9bc41c24c9fc04a1f8b4a7cfdf18283d",
  preinstalledKbWidgetTooltipClosed: "42b082cd74703084942fcbbd9bd16e84",
  topMessageBoxMacrosPromoBannerClosed: "d4d95a38ee3fb44179b1909a4f537335",
  hasSeenDarkModePromoTooltip: "961635b75c2129e768646498de92c416",
  firstLoginDate: "8f4629fa2881861a8ff5065e52a2e770",
  hasClosedSimilarTicketsBanner: "213cbf61ec0e4ab0ebbc1d358d6197f0",
  wasSimilarTicketScrolledIntoView: "ae5672bd7dfe18d75b8ee22ced101801",

  // reports
  handlingTimeByStatusVisitedDate: "e9443d4f1d7aca624b69f61f8b77e008",
  last7DaysVisitedDate: "24829e1137d02009a7fe4a65ccf600cd",
  newTicketsVisitedDate: "62096e98f4cb1ca7607caac82ab51d8b",
  newTicketsHeatmapVisitedDate: "8cdd90be336195eea2d4a1909e88a33a",
  ticketSatisfactionVisitedDate: "69ad06f3b5423f4b940f6289dcc4e0cf",
  firstResponseTimeVisitedDate: "1c4951b0366036305a4ab26fc43ea4d2",
  solvedAndClosedVisitedDate: "ec7e17e7bc2332c37163f4e01dd9e620",
  ticketResolutionTimeVisitedDate: "f32720a064b922f8ec6b220bd2a27708",
  scheduledReportsVisitedDate: "5e8f7130e6d0e827ac4abec5a6b0dcb2",
  auditLogVisitedDate: "2b304d70ac2c0f3adc2ef1552bd0cf8b",

  // context 2024 promotional banners
  isContext2024BannerDisabled: "d065d9f57e150946530ac48f9402b823",
  hasSeenSortingTooltip: "e54f6926b78523a9b1439cccc518a44b",

  // context 2025 promotional banners
  context2025PromoModalClosedDate: "9940a3a8528806dde3b61d0ec511b761",

  // profile menu
  hasSeenAutoAssignmentSwitcherInProfileMenu: "0179dafa8620ef3eedbb30ef5317073f",
  hasClosedProfileMenuAutoAssignmentTooltip: "c939b9ca4f768521439813af6534b2fe",
} satisfies Partial<Record<keyof IAgentFlags, string>>;
